<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-form v-model="referenciaForm" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12">
              <BaseInput class="mb-1" v-model="referencia.nombre" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Nombre completo <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="maskedPhone" v-mask="'###-###-##-##'" maxlength="13" :rules="nameRules">
                <template v-slot:label>Teléfono <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput
                v-model.number="referencia.tiempoConocerse"
                type="number"
                :rules="nameRules"
                min="0"
                validate-on-blur
              >
                <template v-slot:label>Tiempo de ser vecinos (años) <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <div class="col-12">
              <h3>Domicilio</h3>
            </div>
            <v-col cols="6">
              <BaseSelect class="mb-1" v-model="selectedEstado" :items="estados">
                <template v-slot:label>Estado <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="6">
              <BaseSelect class="mb-1" v-model="referencia.fk_idmunicipio" :items="municipiosOptions">
                <template v-slot:label>Municipio <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="4">
              <BaseInput v-model="referencia.cp" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Código Postal <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="8">
              <BaseInput v-model="referencia.colonia" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Colonia <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.localidad" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Localidad <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.calle" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Calle <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.exterior" :rules="nameRules" validate-on-blur>
                <template v-slot:label>No. Exterior <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.interior" :rules="nameRules" validate-on-blur>
                <template v-slot:label>No. Interior <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.entrecalles" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Entre calles <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="referencia.entrecalles2" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Entre calles 2 <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="referencia.referencias" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Referencias <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton
        color="secondary"
        class="px-8"
        :disabled="!referenciaForm || loading"
        :loading="loading"
        v-on:click="triggerSaveReferencia()"
        >Guardar</TextButton
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseSelect from '@/components/base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import ReferenciaEntity from '@src/modules/referencias/domain/ReferenciaEntity'
import { TIPO_REFERENCIAS } from '@modules/referencias/domain/TIPO_REFERENCIAS'

export default {
  components: {
    BaseInput,
    BaseSelect,
    TextButton,
  },

  props: {
    idPersonal: {
      type: Number,
    },

    referenciaToUpdate: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      referenciaForm: false,
      loading: false,
      maskedPhone: '',
      referencia: new ReferenciaEntity(TIPO_REFERENCIAS.VECINAL),
      selectedEstado: null,
      nameRules: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  mounted() {
    if (this.referenciaToUpdate) {
      this.referencia = { ...this.referenciaToUpdate }
      this.maskedPhone = this.referencia.telefono.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1-$2-$3-$4')
      this.selectedEstado = this.estados.find(
        (estado) =>
          estado.id ===
          this.municipios.find((municipio) => municipio.id === this.referencia.fk_idmunicipio)?.fk_idEstado
      )?.id
    }
  },

  computed: {
    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),
    ...mapGetters('estado', {
      estados: 'getEstados',
    }),

    municipiosOptions() {
      return this.municipios
        .filter((municipio) => municipio.fk_idEstado === this.selectedEstado)
        .map((municipio) => ({ id: municipio.id, title: municipio.nombre }))
    },
  },

  methods: {
    ...mapActions('dialog', ['closeDialog']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('referenciaEnlaceC3', ['createReferencia', 'updateReferencia', 'fetchReferenciasByPersonal']),

    async triggerSaveReferencia() {
      try {
        this.loading = true
        this.referencia.telefono = this.maskedPhone.replace(/-/g, '')

        if (this.referenciaToUpdate) {
          await this.updateReferencia({ idPersonal: this.idPersonal, referencia: this.referencia })
        } else {
          await this.createReferencia({ idPersonal: this.idPersonal, referencia: this.referencia })
        }

        this.resetForm()
        this.closeDialog()
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al registrar la referencia.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.referencia = new ReferenciaEntity(TIPO_REFERENCIAS.VECINAL)
      this.maskedPhone = ''
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>
